import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi } from '@/modules';
import { IntoleranceService } from './intolerance.service';
import { Intolerance } from './intolerance.model';
import { wrapError } from '../../error';

const intoleranceApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    intolerances: builder.query<Intolerance[], PatientId>({
      queryFn: ({ patientId }) =>
        IntoleranceService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'Intolerance', id: patientId }
      ]
    }),

    addIntolerance: builder.mutation<
      Intolerance[],
      WithPatientId<{ intolerance: Partial<Intolerance> }>
    >({
      queryFn: ({ patientId, intolerance }) =>
        IntoleranceService.getInstance(patientId)
          .create(intolerance)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'Intolerance', id: patientId },
        'Dashboard'
      ]
    }),

    replaceIntolerances: builder.mutation<
      Intolerance[],
      WithPatientId<{ intolerances: Partial<Intolerance>[] }>
    >({
      queryFn: ({ patientId, intolerances }) =>
        IntoleranceService.getInstance(patientId)
          .replace(intolerances)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'Intolerance', id: patientId },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useIntolerancesQuery,
  useAddIntoleranceMutation,
  useReplaceIntolerancesMutation
} = intoleranceApi;
